<template>
  <div class="row">
    <div class="col-md-12" style="min-height:80vh">
      <p>Check out our articles for guides and info on edibles and dosing.</p>
      <article-stub v-for="a in articles" :article="a" :key="a.title" />
    </div>
  </div>
</template>

<script>
import ArticleStub from "../components/ArticleStub.vue";

export default {
  components: {
    ArticleStub,
  },
  data: function() {
    return {
      articles: [
        {
          title: "How To Use the Scientific Edibles Calculator",
          summary:
            "Follow our in depth guide to estimating your edible potency! This article will walk you through which values to select, and how to make sure your estimate is as accurate as possible.",
          date: "28th July 2020",
          route: "how_to_use_our_calculator",
          stub_img: require("@/assets/articles/how_to/stub.png"),
        },
      ],
    };
  },
  metaInfo: {
    title: "Articles",
  },
};
</script>

<style></style>
